import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';

type SpecializationOptionInterface = {
  label: string;
  value: OrganizationJobPosition;
};

const OTHER_VALUE = OrganizationJobPosition.OrganizationJobPositionOther;

export const sortSpecializationOptions = (
  a: SpecializationOptionInterface,
  b: SpecializationOptionInterface,
) => {
  if (a.value === OTHER_VALUE) {
    return 1;
  }
  if (b.value === OTHER_VALUE) {
    return -1;
  }
  return a.label.localeCompare(b.label);
};
